<template>
  <MainNavbar class="bg-transparent fixed-top border-bottom" mwClass="" className="m-auto" />
  <div class="testimonial-page pt-227 pb-100">
    <div class="container">
      <div class="section-title mw-600">
        <span class="top-title">Get Your Wish</span>
        <h2>Send Your Wish Request</h2>
      </div>
      <form class="wish-form" @submit.prevent="submitWish">
        <div class="form-group">
          <label for="name">Name</label>
          <input id="name" v-model="name" type="text" required />
        </div>
        <div class="form-group">
          <label for="celebrity">Name of Celebrity</label>
          <select id="celebrity" v-model="celebrity" required>
            <option value="">Select Celebrity</option>
            <option value="Sharanya Shetty">Sharanya Shetty</option>
            <option value="Rashmi Prabhakar">Rashmi Prabhakar</option>
            <option value="Aditi Prabhudeva">Aditi Prabhudeva</option>
            <option value="Reeshma Nanaiah">Reeshma Nanaiah</option>
            <option value="Parvati Nair">Parvati Nair</option>
            <option value="Sudhan D">Sudhan D</option>
          </select>
        </div>
        <div class="form-group">
          <label for="occasion">Occasion</label>
          <select id="occasion" v-model="occasion" required>
            <option value="">Select Occasion</option>
            <option value="Birthday">Birthday</option>
            <option value="Anniversary">Anniversary</option>
            <option value="Congratulations">Congratulations</option>
            <option value="Get Well Soon">Get Well Soon</option>
            <option value="Wedding">Wedding</option>
            <option value="Motivation">Motivation</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div class="form-group">
          <label for="message">Description</label>
          <textarea id="message" v-model="message" required></textarea>
        </div>
        <button type="submit">Submit</button>
      </form>
    </div>
  </div>
  <MainFooter />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import MainNavbar from "../components/Layouts/MainNavbar.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "GetYourWishPage",
  components: { MainNavbar, MainFooter },
  setup() {
    const name = ref("");
    const celebrity = ref("");
    const occasion = ref("");
    const message = ref("");
    const whatsappNumber = "919113229933"; // Replace with your WhatsApp number
    const submitWish = () => {
      const text = `Name: ${name.value}\nCelebrity: ${celebrity.value}\nOccasion: ${occasion.value}\nDescription: ${message.value}`;
      const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(text)}`;
      window.open(url, '_blank');
    };
    return { name, celebrity, occasion, message, submitWish };
  },
});
</script>

<style scoped>
.wish-form {
  max-width: 500px;
  margin: 0 auto;
  background: #fec4abff;
  padding: 32px;
  border-radius: 8px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.04);
}
.form-group {
  margin-bottom: 20px;
}
label {
  display: block;
  margin-bottom: 6px;
  color: #333;
}
input, textarea, select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
button[type="submit"] {
  width: 100%;
  padding: 10px;
  background: #f66122ff;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
}
</style>
